import { v4 as uuid } from 'uuid';

export default class EduMaterialModel {
    constructor(index, newUuid) {
        this.order = index;
        this.id = undefined;
        this.text = '<span></span>';
        this.headerPhoto = null;
        this.uuid = newUuid ? newUuid : uuid();

    }
    static copy(from, to) {
        return EduMaterialModel.assingMaterials(from, to);
    }

    static assingMaterials(materialsFrom, materialsTo) {
        materialsTo = [];

        if (!materialsFrom) {
            return materialsTo;
        }
        materialsFrom.forEach((materialFrom, index) => {
            const currentMaterialTo = new EduMaterialModel(index);
            EduMaterialModel.assign(materialFrom, currentMaterialTo, index);
            materialsTo.push(currentMaterialTo);
        });
        return materialsTo;
    }

    static assign(from, to, index) {
        if (from) {
            to.id = from.id;
            to.order = from.order;
            to.text = from.text ? from.text : '';
            to.headerPhoto = from.headerPhoto;
            to.uuid = from.uuid ? from.uuid : uuid();
        } else {
            to = new EduMaterialModel(index);
        }
    }
}